import axios from 'axios'
import updateItem from './updateItem'
import { HOTEL_ENDPOINT } from '../../../helpers/request'

const showMore = async (originalItem, dispatch, { main: { results, queryString } }) => {
  /** @namespace  item.loadingMore */
  if (results.filter(item => item.loadingMore && originalItem.id === item.id).length > 0) {
    return
  }

  try {
    if (!originalItem.more) {
      dispatch(updateItem(originalItem.id, 'loadingMore', true))
      const {data} = await axios.get(`${HOTEL_ENDPOINT}/${originalItem.id}/rooms${queryString}`)
      dispatch(updateItem(originalItem.id, 'more', data))
      dispatch(updateItem(originalItem.id, 'loadingMore', false))
    }
    dispatch(updateItem(originalItem.id, 'isMoreVisible', true))
  } catch (e) {
    dispatch(updateItem(originalItem.id, 'loadingMore', false))
  }
}

export default item => (dispatch, getState) => showMore(item, dispatch, getState())
